<div class="detail-modal-header d-flex flex-row justify-content-between align-items-center" style="min-height: 36px;">
  <h1 style="min-height: 36px;" class="d-flex align-items-center">{{ title }}
    @if (isArchived) {
      <span class="archived">{{ 'archived' | translate }}</span>
    }
    @if (isAdmin) {
      <span class="admin">{{ 'admin' | translate }}</span>
    }
    @if (tile) {
      <span [class]="tileClass" class="tile">{{ tile }}</span>
    }
  </h1>
  <div class="detail-modal-header-button-wrapper">
    @if (mode === ModalMode.DETAIL) {
      @if (isEditable) {
        <app-button
          classes="primary-light"
          text="{{ 'edit' | translate }}"
          icon="pencil"
          (emitClick)="onEditClicked()"
          >
        </app-button>
      }
      @if (isActivatable || isArchivable || isDuplicable || isDeletable) {
        <app-button
          class="position-relative actions"
          classes="primary-light"
          icon="actions"
          iconSize="18px"
          placement="bottom-right"
          [ngbPopover]="popContent"
          >
          <ng-template #popContent>
            <ul>
              @if (isDuplicable) {
                <li class="position-relative" (click)="onDuplicateClicked()">
                  <i class="im-icon im-icon-duplicate"></i>
                  {{ 'duplicate' | translate }}
                </li>
              }
              @if (isArchivable) {
                <li class="position-relative" (click)="onArchiveClicked()">
                  <i class="im-icon im-icon-archive-down"></i>
                  {{ 'archive' | translate }}
                </li>
              }
              @if (isActivatable) {
                <li class="position-relative" (click)="onActivateClicked()">
                  <i class="im-icon im-icon-todo"></i>
                  {{ 'activate' | translate }}
                </li>
              }
              @if (showSendStartLink) {
                <li class="position-relative" (click)="onSendStartLinkClicked()">
                  <i class="im-icon im-icon-send"></i>
                  {{ 'admin_users_detail_send_start_link' | translate }}
                </li>
              }
              @if (isDeletable) {
                <li class="position-relative delete-red" (click)="onDeleteClicked()">
                  <i class="im-icon im-icon-trash"></i>
                  {{ 'delete' | translate }}
                </li>
              }
            </ul>
          </ng-template>
        </app-button>
      }
    }
    @if (mode === ModalMode.EDIT && showEditButtons) {
      <app-button
        classes="primary-default"
        icon="check-round-filled"
        text="{{ (showSendInvitationButton ? 'send_invitation' : 'save') | translate }}"
        [submitting]="submitting"
        (emitClick)="onSaveClicked()"
        >
      </app-button>
      <app-button
        classes="primary-light"
        icon="x-round-filled"
        text="{{ 'cancel' | translate }}"
        [disabled]="submitting"
        (emitClick)="onCancelClicked()"
        >
      </app-button>
    }
  </div>
</div>
